import {get} from "lodash"
import BaseService from "./Base"
import {
    CimaClient,
    CimaClientListRequest,
    CimaGrade,
    CimaGradeListRequest,
    CimaImportRun,
    CimaImportRunListRequest,
    CimaModuleMapping,
    CimaModuleMappingListRequest,
    CimaPaginatedResponse,
    CimaUpdateGradeRequest,
    CimaUpdateGradeResponse,
    CimaUpdateModuleMappingRequest,
    CimaUpdateModuleMappingResponse,
    CimaUpdateUserMappingRequest,
    CimaUpdateUserMappingResponse,
    CimaUserMapping,
    CimaUserMappingListRequest
} from "types/integrations/cima"

class CimaIntegrationService extends BaseService {
    async listClients(params: CimaClientListRequest): Promise<CimaPaginatedResponse<CimaClient>> {
        const response = await this.post("/v1/integrations/cima/clients/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listImportRuns(params: CimaImportRunListRequest): Promise<CimaPaginatedResponse<CimaImportRun>> {
        const response = await this.post("/v1/integrations/cima/import-runs/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async listUserMappings(params: CimaUserMappingListRequest): Promise<CimaPaginatedResponse<CimaUserMapping>> {
        const response = await this.post("/v1/integrations/cima/user-mappings/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async updateUserMapping(params: CimaUpdateUserMappingRequest): Promise<CimaUpdateUserMappingResponse> {
        const response = await this.post("/v1/integrations/cima/user-mappings/update", params)
        return get(response, "data", {
            success: false,
            data: {id: params.mappingId, studentProfileId: params.studentProfileId}
        })
    }

    async listModuleMappings(params: CimaModuleMappingListRequest): Promise<CimaPaginatedResponse<CimaModuleMapping>> {
        const response = await this.post("/v1/integrations/cima/module-mappings/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async updateModuleMapping(params: CimaUpdateModuleMappingRequest): Promise<CimaUpdateModuleMappingResponse> {
        const response = await this.post("/v1/integrations/cima/module-mappings/update", params)
        return get(response, "data", {
            success: false,
            data: {id: params.mappingId, edularCourseId: params.edularCourseId}
        })
    }

    async listGrades(params: CimaGradeListRequest): Promise<CimaPaginatedResponse<CimaGrade>> {
        const response = await this.post("/v1/integrations/cima/grades/list", params)
        return get(response, "data", {success: false, total: 0, data: []})
    }

    async updateGrade(params: CimaUpdateGradeRequest): Promise<CimaUpdateGradeResponse> {
        const response = await this.post("/v1/integrations/cima/grades/update", params)
        return get(response, "data", {success: false, data: {id: params.gradeId}})
    }
}

export default CimaIntegrationService
